/**
 * Barevné kódování úrovní tree-view (PHX-TREE-01 § 1) — barva je vázaná
 * na hloubku úrovně, ne na typ uzlu. Stejné barvy nesou ikony uzlů
 * i tečky hromadného rozbalení; hloubky za 4. úrovní se clampují na L4.
 */

/** Barvy ikon uzlů podle hloubky (L1 oranžová · L2 modrá · L3 zelená · L4 fialová). */
export const LEVEL_TEXT_CLASSES = [
  'text-phx-warning',
  'text-phx-info',
  'text-phx-success',
  'text-phx-purple',
] as const;

/** Neaktivní tečka úrovně: border color-mix(barva 55 %, border-2), hover plná barva. */
export const LEVEL_DOT_IDLE_CLASSES = [
  'border-[color-mix(in_srgb,var(--phx-warning)_55%,var(--phx-border-2))] hover:border-phx-warning',
  'border-[color-mix(in_srgb,var(--phx-info)_55%,var(--phx-border-2))] hover:border-phx-info',
  'border-[color-mix(in_srgb,var(--phx-success)_55%,var(--phx-border-2))] hover:border-phx-success',
  'border-[color-mix(in_srgb,var(--phx-purple)_55%,var(--phx-border-2))] hover:border-phx-purple',
] as const;

/** Aktivní tečka úrovně: vyplněná barvou své úrovně. */
export const LEVEL_DOT_ACTIVE_CLASSES = [
  'border-phx-warning bg-phx-warning',
  'border-phx-info bg-phx-info',
  'border-phx-success bg-phx-success',
  'border-phx-purple bg-phx-purple',
] as const;

/** Index úrovně pro danou hloubku (0-based, clamp na L4). */
export function levelIndex(depth: number): number {
  return Math.min(Math.max(depth, 0), LEVEL_TEXT_CLASSES.length - 1);
}
